/**
 * 系统管理 菜单管理
 */
<template>
  <div class="main">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>案例管理</el-breadcrumb-item>
      <el-breadcrumb-item>用户回访</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formCase" class="user-search">
          <el-form-item label="搜索：">
           <!-- <el-select size="small" v-model="formCase.isLock" placeholder="请选择">
              <el-option label="全部" value=""></el-option>
              <el-option label="正常" value="N"></el-option>
              <el-option label="已锁定" value="Y"></el-option>
            </el-select> -->
          </el-form-item>

          <el-form-item label="案例名称">
            <el-input size="small" v-model="formCase.caseName" placeholder="输入案例名称"></el-input>
          </el-form-item>
          <!-- <el-form-item label="案例类型">
           <el-select size="small" v-model="formCase.caseCategory" placeholder="请选择">
              <el-option label="全部" value=""></el-option>
              <el-option label="精品案例" value="BOUTIQUE"></el-option>
              <el-option label="用户回访" value="CALLBACK"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="内容类型">
           <el-select size="small" v-model="formCase.caseType" placeholder="请选择">
              <el-option label="全部" value=""></el-option>
              <el-option label="视频/图文案例" value="IMAGE_TEXT"></el-option>
              <el-option label="案例链接" value="CASE_LINK"></el-option>
              <el-option label="案例文件" value="CASE_PDF"></el-option>
              <!-- <el-option label="纽恩泰案例" value="CASE_ENERGY"></el-option> -->
            </el-select>
          </el-form-item>
    	  
          <el-form-item>
            <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            <!-- <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button> -->
          </el-form-item>
        </el-form>
        <!--列表-->
        <el-table size="small" @selection-change="selectChange" :data="caseList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column align="center" type="selection" width="50">
          </el-table-column>
          <el-table-column align="center" sortable prop="caseName" label="案例名称" >
          </el-table-column>
          <el-table-column align="center" sortable prop="caseType" label="内容载体"  :formatter="caseTypeFormatter">
            
          </el-table-column>
    	  <el-table-column align="center" sortable prop="readNum" label="阅读量" >
    	  </el-table-column>
		  <el-table-column align="center" sortable prop="transmitNum" label="转发分享" >
		  </el-table-column>
          <!-- <el-table-column align="center" sortable prop="createTime" label="案例类型" min-width="140">
          </el-table-column> -->
		  <el-table-column align="center" sortable prop="createTime" label="创建时间" >
		  </el-table-column>
         <!-- <el-table-column align="center" sortable prop="editTime" label="修改时间" min-width="120">
            <template slot-scope="scope">
              <div>{{scope.row.editTime|timestampToTime}}</div>
            </template>
          </el-table-column> -->
          <!-- <el-table-column align="center" sortable prop="status" label="状态" min-width="100">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.status=='1'?nshow:fshow" active-color="#13ce66" inactive-color="#ff4949" @change="editType(scope.$index, scope.row)">
              </el-switch>
            </template>
          </el-table-column> -->
          <el-table-column  align="center"  label="操作" >
            <template slot-scope="scope">

              <!-- <el-button size="mini" type="success" @click="getDatas(scope.$index, scope.row.id)">查看</el-button> -->
              <el-button size="mini"  type="primary" @click="handleEdit(scope.$index, scope.row)">查看</el-button>
			  <el-button size="mini" type="danger" @click="deleteCase(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <!-- 编辑界面 -->
        <el-dialog :title="title" :visible.sync="editFormVisible" width="70%" @click='closeDialog("edit")'>
          <el-form label-width="120px" ref="editForm" :model="editForm" >
            <el-form-item label="案例名称" prop="caseName">
              <el-input size="small" v-model="editForm.caseName" auto-complete="off" placeholder="请输入案例名称"></el-input>
            </el-form-item>
            <!-- <el-form-item label="案例类型" :prop="editForm.caseCategory">
              <el-radio v-model="editForm.caseCategory" label="BOUTIQUE">精品案例</el-radio>
              <el-radio v-model="editForm.caseCategory" label="CALLBACK">用户回访</el-radio>
            </el-form-item> -->
            <!-- <el-form-item label="案例类型" :prop="editForm.productType">
              <el-radio v-model="editForm.productType" label="0">家用</el-radio>
              <el-radio v-model="editForm.productType" label="1">商用</el-radio>
            </el-form-item> -->
            <el-form-item label="内容类型" :prop="editForm.caseType">
              <el-radio v-model="editForm.caseType" label="CASE_LINK">链接</el-radio>
              <el-radio v-model="editForm.caseType" label="IMAGE_TEXT">视频/图文</el-radio>
              <el-radio v-model="editForm.caseType" label="CASE_PDF">文件</el-radio>
            </el-form-item>
            <el-form-item  label="链接信息" v-if="editForm.caseType == 'CASE_LINK'">
              <el-input size="small" v-model="editForm.url" auto-complete="off" placeholder="请输入网址"></el-input>
              <div class="el-upload__tip">请输入以“http://”或者“https://” 开头的网址链接</div>
            </el-form-item>
            <el-form-item  label="文件信息"  v-if="editForm.caseType == 'CASE_PDF'">
              <!-- accept=".png,.jpeg,.gif,.pdf,.jpg,.JPG" -->
              <el-upload
                class="upload-files"
                v-model="diaFrom.list"
                :limit="3"
                :on-exceed="handleExceed"
                :on-preview="handlePreview"
                :before-upload="beforeAvatarUpload"
                :on-remove="handleRemove"
                :on-success="onUploadSuccess"
                :file-list="resultFilelist"
                list-type="picture"
                :action="uploadUrl()"
                :http-request="customUpload"
                accept=".pdf">
                <el-button size="small" type="primary">点击上传文件</el-button>
                <div slot="tip" class="el-upload__tip">上传文件，仅支持PDF文件，最多可上传3份文件</div>
                
              </el-upload>
            </el-form-item>
            <div v-if="editForm.caseType == 'IMAGE_TEXT'">
              <el-form-item label="金额" prop="amount">
                <el-input size="small" v-model="editForm.amount" auto-complete="off" placeholder="请输入案例金额"></el-input>
              </el-form-item>
              <el-form-item label="类型" >
                <el-checkbox-group v-model="typeList">
                  <el-checkbox :label="tItem.name" v-model="tItem.checked" v-for="(tItem,tIndex) in typeLists" :key="tIndex"></el-checkbox>
                  
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="面积" >
                <el-checkbox-group v-model="areaList">
                  <el-checkbox :label="aItem.name" v-model="aItem.checked" v-for="(aItem,aIndex) in areaLists" :key="aIndex"></el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="楼层" >
                <el-checkbox-group v-model="floorList">
                  <el-checkbox :label="fItem.name" v-model="fItem.checked" v-for="(fItem,fIndex) in floorLists" :key="fIndex"></el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            <el-form-item label="附件类型" :prop="editForm.attachType">
              <el-radio v-model="editForm.attachType" label="1">图片</el-radio>
              <el-radio v-model="editForm.attachType" label="2">视频</el-radio>
            </el-form-item>
            <el-form-item   label="场地图片"  v-show="editForm.attachType == 1">
              
              <el-upload
                class="upload-demo"
                :action="uploadUrl()"
                :http-request="customUpload"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :file-list="resultFilelist1"
                :limit='9'
				:disabled='isUpload1'
                accept=".png,.jpg,.jpeg"
                list-type="picture-card">
				<div slot="file" slot-scope="{file}">
					<el-progress type="circle" :percentage="progressPercent1" v-if="isUpload1 && file.status != 'complete'"></el-progress>
				  <img
				    class="el-upload-list__item-thumbnail"
				    :src="file.url" alt=""
				  >
				  <span class="el-upload-list__item-actions">
				    <span
				      class="el-upload-list__item-preview"
				      @click="handlePreview(file)"
				    >
				      <i class="el-icon-zoom-in"></i>
				    </span>
				    
				    <span
				      class="el-upload-list__item-delete"
				      @click="handleRemove(file)"
				    >
				      <i class="el-icon-delete"></i>
				    </span>
				  </span>
				</div>
                <el-button size="small" type="primary" @click="tips">点击上传图片</el-button>
                <div slot="tip" class="el-upload__tip">只能上传jpg、jpeg、png 图片，最多可上传9张图片</div>
              </el-upload>
              
            </el-form-item>

            <el-form-item   label="场地视频"  v-show="editForm.attachType == 2">
              
              <el-upload
                class="upload-demo"
                :action="uploadUrl()"
                :http-request="customUpload"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :file-list="resultFilelist2"
				:disabled='isUpload'
                :limit='9'
                accept=".mp4,.avi,.mpeg"
                list-type="picture-card">
                <el-button size="small" type="primary"  @click="tips1">点击上传视频</el-button>
                <div slot="tip" class="el-upload__tip">只能上传mp4、avi、mpeg 视频，最多可上传9个视频</div>
                <div slot="file" slot-scope="{file}">
					<el-progress type="circle" :percentage="progressPercent" v-if="isUpload && file.status != 'complete'"></el-progress>
                  <video
                    class="el-upload-list__item-thumbnail"
                    :src="file.url" alt=""
                    :autoplay="true"
                  ></video>
                  <span class="el-upload-list__item-actions">
                    <span
                      class="el-upload-list__item-preview"
                      @click="handlePreview(file)"
                    >
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    
                    <span
                      class="el-upload-list__item-delete"
                      @click="handleRemove(file)"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
              </el-upload>
              
            </el-form-item>
            
            <el-form-item   label="描述"  >
              <el-input style="margin-top:10px"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4}"
                placeholder="描述"
                v-model="editForm.caseDesc">
              </el-input>
            </el-form-item>
          </div>


            
          </el-form>

          <el-dialog :visible.sync="imgVisible" :append-to-body="true" style="" :title="imgTitle">
            <div style="justify-content:center;align-item:center;text-align:center;display:flex" >
              <el-image
                style="width:100%;min-height:400px"
                :src="imgUrl"
              fit="contain" v-if="editForm.attachType == 1"></el-image>
              <video style="width:100%;height:500px" v-if="editForm.attachType == 2"
                    class=""
                    :src="imgUrl" alt=""
                    :autoplay="true"
                    :poster="true"
                    :controls="true"
                  ></video>
            </div>
          </el-dialog>


          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
            <el-button size="small" type="primary" :loading="loading" class="title" @click="saveCase">保存</el-button>
          </div>
          



        </el-dialog>
      </div>
    </template>

    <script>
    // 导入请求方法
    import { uploadFile } from '../../api/axiosFun';
    import {
      deleteCase,
      modifyCase,
      createCase,
      getCase,
      getCaseList
      } from '../../api/knowledgeFun'
    import Pagination from '../../components/Pagination'

  
    import {evaluateUpload }from '@/api/auth';
    import { setCookie, getCookie, delCookie } from '../../utils/util'



    export default {
      data() {
        return {
		  isUpload1: false,//文件是否上传中
		  progressPercent1: 0,//进度条当前进度
		  timer1:null,
		  isUpload: false,//文件是否上传中
		  progressPercent: 0,//进度条当前进度
		  timer:null,
          dateValue:[],
          textarea2:'',
          loading: false, //是显示加载
          title: '',
          editFormVisible: false, //控制编辑页面显示与隐藏
          dataAccessshow: false, //控制数据权限显示与隐藏
          unitAccessshow: false, //控制所属单位隐藏与显示
          // 编辑与添加
          editForm: {
            caseId:'',
            caseName: '',
            amount: '',
            attachType:'1',
            caseCategory:'CALLBACK',
            imageIdList: [],
            caseType: 'IMAGE_TEXT',
            caseDesc:'',
            imageCaseItemDtoList:[{
                "itemType": "TYPE",
                "itemValue": []
            }, {
                "itemType": "AREA",
                "itemValue": []
            }, {
                "itemType": "FLOOR",
                "itemValue": []
            }],
            url:'',
            fileIdList:[],
            caseModel:"HQ_CASE"
          },
          src:'',
          srcList:[],
          typeList:[],
          areaList:[],
          floorList:[],
          typeLists:[
					{
						name: '自建房',
						checked:false
					},
					{
						name: '别墅',
						checked:false
					},
					{
						name: '商品房',
						checked:false
					},
				],
				areaLists:[
					{
						name: '≥300',
						checked:false
					},
					{
						name: '≥150',
						checked:false
					},
					{
						name:  '≥100',
						checked:false
					},
				],
				floorLists:[
					{
						name: '三层',
						checked:false
					},
					{
						name: '两层',
						checked:false
					},
					{
						name: '一层',
						checked:false
					},
				],
          // 选择数据
          selectdata: [],
          

          // 请求数据参数
          formCase: {
            pageIndex: 1,
            pageSize: 10,
            // 案例名称(支持右模糊查询)
            name: '',
            //创建人(支持右模糊查询)
            caseType: '',
            //内容类型（0：链接，1：视频/图文，2：文件）,默认-1（即不使用此过滤）
            // caseType:-1,
            // //案例类型（0：家用，1：商用）,默认-1（即不使用此过滤）
            // productType:-1,
            // // 客户案例类型（0：客户案例，1：案例卖点，2：安装视频）,默认''（即不使用此过滤）
            caseCategory:'CALLBACK',
            // createStartTime:'',
            // createEndTime:''
          },
    	  
          //客户案例列表
          caseList: [],
         
          
          // 分页参数
          pageparm: {
            currentPage: 1,
            pageSize: 10,
            total:0,
          },
          diaFrom:{
            desc:'',
            list:[]
          },
          resultFilelist:[],
          resultFilelist1:[],
          resultFilelist2:[],
          fileList: [],
          imgVisible:false,
          imgTitle:'',
          imgUrl:''
         
        }
      },
      // 注册组件
      components: {
        Pagination
      },

      /**
       * 数据发生改变
       */
      watch: {},

      /**
       * 创建完毕
       */
      created() {
        this.getData(this.formCase)

      },
      mounted(){
        // document.addEventListener("paste", this.handlePaste);
      },
      beforeDestroy(){
        // document.removeEventListener("paste",this.handlePaste);
      },
      /**
       * 里面的方法只有被调用才会执行
       */
      methods: {
		tips(){
			if(this.isUpload1){
				this.$message.warning('图片还在上传')
			}
		},
		tips1(){
			if(this.isUpload){
				this.$message.warning('视频还在上传')
			}
		},
        caseTypeFormatter(row,column){
          let caseTypeName = row.caseType == 'CASE_LINK' ?'链接' :row.caseType == 'IMAGE_TEXT' ?'视频/图文':'文件' 
          return caseTypeName
          
        },
        editFormInit(){
          this.editForm = {
            caseId:'',
            caseName: '',
            productType: '0',
            caseCategory: 'CALLBACK',
            caseType: 'CASE_LINK',
            description:'',
            content:[],
            linkUrl:'',
            attachments:[],
            attachType:'1'
          }
          this.typeList=[]
         this.areaList=[]
          this.floorList=[]
          this.resultFilelist1 = []
          this.resultFilelist2 = []
          this.resultFilelist = []
        },
       

        //限制上传个数不超过9个
        handleExceed(files,fileList){
          if(fileList && fileList.length == 3){
            this.$message.warning('上传文件不可超过3个')
          }
        },
        handlePreview(file){
          console.log(file)
          if(this.editForm.caseType  == 'CASE_PDF'){
            window.open(file.fileTemporaryUrl)
            // const index = this.resultFilelist.findIndex(item => item.fileId === file.fileId)
            // this.resultFilelist.splice(index,1);
          }else if(this.editForm.caseType  == 'IMAGE_TEXT'){
            this.imgUrl = file.fileTemporaryUrl
            this.imgVisible = true
            this.imgTitle = file.name
          }
        },
        beforeAvatarUpload(file){
          console.log(file)
        },
        customUpload(req){
          let _this = this
          console.log(req)
           // 创建一个新的FormData对象
          const formData = new FormData();
          // 将文件添加到formData中
          formData.append('file', req.file);
		  if(_this.editForm.attachType == 1){
			  this.isUpload1 = true
			  this.progressPercent1 = 0
			  clearInterval(_this.timer1)
			  _this.timer1 = null
			  this.timer1 = setInterval(()=>{
				  if(_this.progressPercent1 >= 95){
					  clearInterval(_this.timer1)
					  _this.timer1 = null
				  }else{
					  _this.progressPercent1 += 1
				  }
			  },50)
		  }
		  
		  if(_this.editForm.attachType == 2){
			  this.isUpload = true
			  this.progressPercent = 0
			  clearInterval(_this.timer)
			  _this.timer = null
			  this.timer = setInterval(()=>{
				  if(_this.progressPercent >= 95){
					  clearInterval(_this.timer)
					  _this.timer = null
				  }else{
					  _this.progressPercent += 1
				  }
			  },50)
		  }
          
            uploadFile(this.uploadUrl(), formData).then(response => {
              if(response.data.success){
                let data = response.data.data
                console.log(data)
                // _this.editForm.attachments.push(data)
                if(_this.editForm.caseType == 'CASE_PDF'){
                  _this.resultFilelist.push({
                      url:require('../../assets/img/pdf.png'),
                      fileTemporaryUrl:data.fileTemporaryUrl,
                      fileId:data.fileId,
                      name: data.ossFile.fileName,
                      uid: req.file.uid,
                      attachments:data
                  })
                }else if(_this.editForm.caseType == 'IMAGE_TEXT'){
                  if(_this.editForm.attachType == 1){
					  _this.progressPercent1 = 95
					  clearInterval(_this.timer1)
					  _this.timer1 = null
					  _this.timer1 = setInterval(()=>{
						  if(_this.progressPercent1 >= 100){
							  _this.isUpload1 = false
							  clearInterval(_this.timer1)
							  _this.timer1 = null
						  }else{
							  _this.progressPercent1 += 1
						  }
					  },50)
                      _this.resultFilelist1.push({
                              url:data.fileTemporaryUrl,
                              fileTemporaryUrl:data.fileTemporaryUrl,
                              fileId:data.fileId,
                              name: data.ossFile.fileName,
                              uid: req.file.uid,
                              mediaObjInfo:data,
							  status:'complete'
                          })
                  }else if(_this.editForm.attachType == 2){
					  _this.progressPercent = 95
					  clearInterval(_this.timer)
					  _this.timer = null
					  _this.timer = setInterval(()=>{
						  if(_this.progressPercent >= 100){
							  _this.isUpload = false
							  clearInterval(_this.timer)
							  _this.timer = null
						  }else{
							  _this.progressPercent += 1
						  }
					  },50)
                      _this.resultFilelist2.push({
                              url:data.fileTemporaryUrl,
                              fileTemporaryUrl:data.fileTemporaryUrl,
                              fileId:data.fileId,
                              name: data.ossFile.fileName,
                              uid: req.file.uid,
                              mediaObjInfo:data,
							  status:'complete'
                          })
                  }
                  
                }
                
              }else{
                this.$message.error('文件上传失败，请稍后再试！')
              }
             
                
              console.log(_this.resultFilelist)
              // 处理响应
            }).catch(error => {
              // 处理错误
              console.log(error)
               this.$message.error('文件上传失败，请稍后再试！')
            });
        },
        handleRemove(file,fileList){
          let _this = this
          console.log(file)
          if(!file){
            return
          }
          if(this.editForm.caseType  == 'CASE_PDF'){
            const index = this.resultFilelist.findIndex(item => item.fileId === file.fileId)
            this.resultFilelist.splice(index,1);
          }else if(this.editForm.caseType  == 'IMAGE_TEXT'){
            if(_this.editForm.attachType == 1){
                const index1 = this.resultFilelist1.findIndex(item => item.fileId === file.fileId)
                console.log(index1)
                this.resultFilelist1.splice(index1,1);
            }else if(_this.editForm.attachType == 2){
               const index2 = this.resultFilelist2.findIndex(item => item.fileId === file.fileId)
                console.log(index2)
                this.resultFilelist2.splice(index2,1);
            }


            
          }
          
        },
        // 设置请求头里面的token 称 userId
        // reqHeaders(){
        //   return {
        //     'Content-Type':'multipart/form-data',
        //     satoken:getCookie('satoken'),
        //   };
        // },  
        onUploadSuccess(response,file,fileList){
          console.log('onUploadSuccess',response)
          // if(response && response.code ==='APPLY_SUCCESS'){
          //     if(response.data){
          //       this.resultFilelist.push({
          //           url:response.data.url,
          //           name: response.data.name,
          //           uid: file.uid
          //       })
          //       // this.dealPDF();
          //       // setTimeout(()=>{
          //       //   this.dealPDF();
          //       // },1);
          //     }
          //   }else if (response && response.msg){ 
          //     console.log('upload failed', response.msg);
          //   }
        },
        uploadUrl(){
          return '/mtl/marking/api/main/oss-file/upload-file'
        },
        dealPDF(){
            var liElements = document.querySelectorAll('ul.el-upload-list,el-upload-list--picture li.el-upload-list__item');
            liElements.forEach(function(liElement){
              var aElement = liElement.querySelector('a.el-upload-list__item-name');
              if(aElement && (aElement.textContent.includes('.pdf') || aElement.textContent.includes('.doc') || aElement.textContent.includes('.docx') || aElement.textContent.includes('.ppt') || aElement.textContent.includes('.pptx'))){
                var imgElement = liElement.querySelector('img.el-upload-list__item-thumbnail')
                if(imgElement){
                  imgElement.src= require('../../assets/img/pdf.png');// 普换为你想要的新图片的URL
                }
              }
            })
        },

		  // 获取数据方法
		  getDatas(index, row) {
		    this.loading = true

		    let pageparm= {
		      pageIndex: 1,
		      pageSize: 10,
		     name: '',
		     parentMenuCode:''
		    }
		    console.log(777,row)
		    if(row != undefined && row != 'undefined'){
		  	  pageparm.parentMenuCode = row
		    }

		    ModuleNodes(pageparm).then(res => {
		      this.loading = false
		      if (res.success == false) {
		        this.$message({
		          type: 'info',
		          message: res.msg
		        })
		      } else {
		        this.caseList = res.data

		        // 分页赋值
            this.pageparm.currentPage = this.formCase.pageIndex
            this.pageparm.pageSize = this.formCase.pageSize
            this.pageparm.total = res.total
		      }
		    })
		  },
        // 获取数据方法
        getData(pageparm) {
          this.loading = true
          console.log(pageparm)
          // if(this.dateValue.length > 0){
          //   pageparm.createStartTime = this.dateValue[0]
          //   pageparm.createEndTime = this.dateValue[1]
          // }

          getCaseList(pageparm).then(res => {
            console.log(123)
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.caseList = res.data

              // 分页赋值
                this.pageparm.currentPage = this.formCase.pageIndex
                this.pageparm.pageSize = this.formCase.pageSize
                this.pageparm.total = res.total
            }
          })
        },
        // 分页插件事件
        callFather(parm) {
          this.formCase.pageIndex = parm.currentPage
          this.formCase.pageSize = parm.pageSize
          this.getData(this.formCase)
        },
        //搜索事件
        search() {
          console.log(123)
          console.log(this.dateValue)
          this.formCase.pageIndex = 1
          this.getData(this.formCase)
        },


        // 修改type
        editType: function(index, row) {
          this.loading = true
          let parm = {
            menuCode: '',
            status: ''
          }
          parm.menuCode = row.menuCode
          let lock = row.status
		  console.log(55,lock)
          if (lock == 0) {
            parm.status = 1
          } else {
            parm.status = 0
          }
          // 修改状态
          Modulestate(parm).then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.$message({
                type: 'success',
                message: '状态修改成功'
              })
			        this.formCase.parentMenuCode = row.parentCode
              this.getData(this.formCase)
            }
          })
        },
        //显示编辑界面
        handleEdit: function(index, row) {
          let _this = this
          this.editFormVisible = true
          if (row != undefined && row != 'undefined') {
            this.title = '客户案例详情'
            getCase(row.caseId)
              .then(res => {
                console.log(res)
                this.loading = false
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg+'TraceId:'+res.traceId
                  })
                } else {
                  console.log(res)
                  let data = res.data
                  this.editForm.caseType = data.caseType
                  this.editForm.caseId =  data.caseId
                  this.editForm.caseName = data.caseName
                  this.editForm.caseCategory = data.caseCategory

                  if(_this.editForm.caseType == 'IMAGE_TEXT'){
						
                    this.editForm.amount = data.amount
                    this.editForm.caseDesc = data.caseDesc
                    _this.editForm.attachType = data.attachType.toString()

                    data.imageCaseItemDtoList.map((item,index)=>{
                      if(item.itemType == 'FLOOR'){
                        _this.floorList = item.itemValue
                      }
                      if(item.itemType == 'AREA'){
                        _this.areaList = item.itemValue
                      }
                      if(item.itemType == 'TYPE'){
                        _this.typeList = item.itemValue
                      }
                    })
                    
                    this.resultFilelist1 = []
                    this.resultFilelist2 = []
                    if(_this.editForm.attachType == 1){
                        data.mediaObjInfoList.map((item,index)=>{
                            this.resultFilelist1.push({
                              url:item.fileTemporaryUrl,
                              fileTemporaryUrl:item.fileTemporaryUrl,
                              fileId:item.fileId,
                              name: item.ossFile.fileName,
                            })
                            
                        })
                    }else if(_this.editForm.attachType == 2){
                        data.mediaObjInfoList.map((item,index)=>{
                            this.resultFilelist2.push({
                              url:item.fileTemporaryUrl,
                              fileTemporaryUrl:item.fileTemporaryUrl,
                              fileId:item.fileId,
                              name: item.ossFile.fileName,
                            })
                            
                        })
                    }
                      

                    // _this.editForm.imageIdList = []
                    // this.filePaths = []
                    // this.fileLists = []
                    // if(data.mediaObjInfoList.length > 0){
                    //   data.mediaObjInfoList.map((item,index)=>{
                    //     _this.editForm.imageIdList.push(item.fileId)
                    //     _this.filePaths.push(item.fileTemporaryUrl)
                    //     _this.fileLists.push({
                    //       url:item.fileTemporaryUrl
                    //     })
                    //   })
                    // }
                    
                    
                  }else if(_this.editForm.caseType == 'CASE_LINK'){
                    
                    _this.editForm.url = data.url
                      
                  }else if(_this.editForm.caseType == 'CASE_PDF'){

                    this.resultFilelist = []
                      data.mediaObjInfoList.map((item,index)=>{
                        this.resultFilelist.push({
                            url:require('../../assets/img/pdf.png'),
                            fileTemporaryUrl:item.fileTemporaryUrl,
                            fileId:item.fileId,
                            name: item.ossFile.fileName,
                            // uid: req.file.uid,
                            attachments:item
                          })
                          
                      })
                      this.dealPDF();
                      setTimeout(()=>{
                        this.dealPDF();
                      },1);
                  }else if(this.editForm.caseType  == 'CASE_ENERGY'){
                    // if(!_this.case3.caseName || _this.case3.fileIdList.length <= 0 ){
                    // 	return _this._msg('请填写完整案例信息')
                    // }else{
                    // 	data = this.case3
                    // }
                  }

            	  // this.editForm.menuName = res.data.menuName
            	  // this.editForm.menuCode = res.data.menuCode
            	  // this.editForm.type = res.data.type
            	  // this.editForm.sorted = res.data.sorted
				        // this.editForm.status = res.data.status.toString()

                }
              })

          } else {
            this.title = '新增客户案例'
            this.editFormInit()
          }
        },
        // 编辑、添加提交方法
        saveCase(){
          let _this = this
          // return false
            console.log(this.content)
             if(!this.editForm.caseName){
              return this.$message({
                      type: 'warning',
                      message: '请填写案例名称'
                    })
            }
            
          let parm = {
            caseId:this.editForm.caseId,
            caseName: this.editForm.caseName,
            caseCategory : this.editForm.caseCategory,
            caseModel: "HQ_CASE"
          }
          if(this.editForm.caseType  == 'CASE_LINK'){
            let linkReg = /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)(([A-Za-z0-9-~]+).)+([A-Za-z0-9-~\/])+$/
            const isLink = linkReg.test(this.editForm.url)
            if(!isLink){
              return this.$message({
                      type: 'warning',
                      message: '请填写正确的链接地址'
                    })
            }
            parm = {
              ...parm,
              url:this.editForm.url
            }
            // parm.append('linkUrl', this.editForm.url);
          }else if(this.editForm.caseType  == 'IMAGE_TEXT'){
            let resultFilelistIMAGE_TEXT = []
            if(_this.editForm.attachType == 1){
                resultFilelistIMAGE_TEXT = this.resultFilelist1
            }else if(_this.editForm.attachType == 2){
               resultFilelistIMAGE_TEXT = this.resultFilelist2
            }
            if(resultFilelistIMAGE_TEXT.length < 1){
              return this.$message({
                      type: 'warning',
                      message: '请上传图片'
                    })
            }
            if(this.typeList.length < 1 || this.floorList.length < 1 || this.areaList.length < 1 || !this.editForm.amount){
              return this.$message({
                      type: 'warning',
                      message: '请完善案例信息'
                    })
            }
            
            let imageIdList = []
            resultFilelistIMAGE_TEXT.map((item,index)=>{
              imageIdList.push(item.fileId)
            })
            parm = {
              ...parm,
              attachType:this.editForm.attachType,
              imageIdList:imageIdList,
              caseDesc:this.editForm.caseDesc,
              amount:this.editForm.amount,
              imageCaseItemDtoList: [{
								itemType: "TYPE",
								itemValue: _this.typeList
							}, {
								itemType: "AREA",
								itemValue: _this.areaList
							}, {
								itemType: "FLOOR",
								itemValue: _this.floorList
							}]
            }
          }else if(this.editForm.caseType  == 'CASE_PDF'){
            if(this.resultFilelist.length < 1){
              return this.$message({
                      type: 'warning',
                      message: '请上传文件'
                    })
            }
            let fileIdList = []
            this.resultFilelist.map((item,index)=>{
              fileIdList.push(item.fileId)
            })
            parm = {
              ...parm,
              fileIdList:fileIdList
            }
          }
          if(this.editForm.caseId){
            parm = {
              ...parm,
              caseId:this.editForm.caseId
            }
          }
          console.log(parm)
    		  if(this.title=='客户案例详情'){
          modifyCase(this.editForm.caseType ,parm)
    				.then(res => {
    				  this.editFormVisible = false
    				  this.loading = false
    				  if (res.success) {
              this.getData(this.formCase)
              this.editFormInit()
    					this.$message({
    					  type: 'success',
    					  message: '保存成功！'
    					})
    				  } else {
    					this.$message({
    					  type: 'info',
    					  message: res.msg
    					})
    				  }
    				})
    				.catch(err => {
    				  this.editFormVisible = false
    				  this.loading = false
    				  this.$message.error('保存失败，请稍后再试！')
    				})
    			}else{

					
          createCase(this.editForm.caseType ,parm)
    					.then(res => {
                this.loading = false
                this.editFormVisible = false
    					  if (res.success) {
                this.getData(this.formCase)
                this.editFormInit()
    						this.$message({
    						  type: 'success',
    						  message: '保存成功！'
    						})
    					  } else {
    						this.$message({
    						  type: 'info',
    						  message: res.msg
    						})
    					  }
    					})
    					.catch(err => {
    					  this.editFormVisible = false
    					  this.loading = false
    					  this.$message.error('保存失败，请稍后再试！')
    					})
    			}
            // } else {
            //   return false
            // }
          // })
        },

        handleClick(data, checked, node) {
          if (checked) {
            this.$refs.tree.setCheckedNodes([])
            this.$refs.tree.setCheckedNodes([data])
            this.unitparm.deptId = data.id
            this.unitparm.deptName = data.name
            //交叉点击节点
          } else {
          }
        },

        // 选择复选框事件
        selectChange(val) {
          this.selectdata = val
        },
        // 关闭编辑、增加弹出框
        closeDialog(dialog) {
          if (dialog == 'edit') {
            this.editFormVisible = false
          } else if (dialog == 'perm') {
            this.dataAccessshow = false
          } else if (dialog == 'unit') {
            this.unitAccessshow = false
          }
        },
        // 删除用户
        deleteCase(index, row) {
          this.$confirm('确定要删除吗?', '信息', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              // 删除
              deleteCase(row.caseId)
                .then(res => {
                  if (res.success) {
                    this.$message({
                      type: 'success',
                      message: '数据已删除!'
                    })
                    this.getData(this.formCase)
                  } else {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  }
                })
                .catch(err => {
                  this.loading = false
                  this.$message.error('数据删除失败，请稍后再试！')
                })
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除！'
              })
            })
        }

      }
    }
    </script>

    <style scoped>
    .user-search {
      margin-top: 20px;
    }
    .userRole {
      width: 100%;
    }
    .main{
    	background-color: #fff;
    	padding: 30px;
    	border-radius: 10px;
    }
    /* .avatar-uploader{
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
    } */
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
    </style>





// WEBPACK FOOTER //
// src/views/knowledge/customerCaseCallback.vue